import { SVGProps } from 'react';

export default function Order9(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3444)">
        <path
          d="M15.8333 0H4.16667C1.86917 0 0 1.86917 0 4.16667V5C0 5.73833 0.3225 6.40333 0.833333 6.86167V15.8333C0.833333 18.1308 2.7025 20 5 20H15C17.2975 20 19.1667 18.1308 19.1667 15.8333V6.86167C19.6775 6.40333 20 5.73917 20 5V4.16667C20 1.86917 18.1308 0 15.8333 0ZM1.66667 4.16667C1.66667 2.78833 2.78833 1.66667 4.16667 1.66667H15.8333C17.2117 1.66667 18.3333 2.78833 18.3333 4.16667V5C18.3333 5.22101 18.2455 5.43297 18.0893 5.58926C17.933 5.74554 17.721 5.83333 17.5 5.83333H2.5C2.04083 5.83333 1.66667 5.46 1.66667 5V4.16667ZM17.5 15.8333C17.5 17.2117 16.3783 18.3333 15 18.3333H5C3.62167 18.3333 2.5 17.2117 2.5 15.8333V7.5H17.5V15.8333ZM5.24583 13.0917C5.08891 12.9359 5.00032 12.7241 4.99954 12.5029C4.99875 12.2818 5.08585 12.0694 5.24167 11.9125C5.39748 11.7556 5.60925 11.667 5.83039 11.6662C6.05152 11.6654 6.26391 11.7525 6.42083 11.9083L8.4475 13.92C8.6054 14.0735 8.81679 14.1596 9.03699 14.16C9.2572 14.1605 9.46895 14.0753 9.6275 13.9225L13.5992 10.2242C13.7618 10.0791 13.9747 10.0035 14.1924 10.0136C14.41 10.0236 14.6151 10.1185 14.7637 10.278C14.9122 10.4374 14.9924 10.6487 14.987 10.8665C14.9817 11.0843 14.8912 11.2914 14.735 11.4433L10.785 15.1217C10.3342 15.5733 9.70667 15.8333 9.03833 15.8333C8.37 15.8333 7.7425 15.5733 7.27 15.1008L5.24583 13.0917Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3444">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
